import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isSelected"];
import styled, { css, mediaQuery } from 'academy-common-lib/utils/Styling';
import { CALYPSO } from 'HubStyleTokens/colors';
import UISelectableButton from 'UIComponents/button/UISelectableButton';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCertificateButtonWrapper = styled(UISelectableButton).withConfig({
  displayName: "CertificateButtonWrapper__StyledCertificateButtonWrapper",
  componentId: "sc-1wnogz-0"
})(["min-width:248px;max-width:unset !important;width:max-content !important;padding:0 16px;&& > div{padding:0 !important;}", " ", ""], mediaQuery('desktop', css(["margin-bottom:16px;"])), mediaQuery('mobile', css(["width:100% !important;&& > *:first-child{min-height:40px !important;}"])));
export const CertificateButtonInnerRightButton = styled.div.withConfig({
  displayName: "CertificateButtonWrapper__CertificateButtonInnerRightButton",
  componentId: "sc-1wnogz-1"
})(["height:100%;display:flex;align-items:center;margin-right:-16px;padding-right:16px;"]);
export const CertificateButtonIconContainer = styled.div.withConfig({
  displayName: "CertificateButtonWrapper__CertificateButtonIconContainer",
  componentId: "sc-1wnogz-2"
})(["position:relative;padding:12px 0 12px 10px;&::before{content:'';position:absolute;left:0;width:1px;height:60%;background-color:", ";opacity:0.5;top:20%;}"], CALYPSO);
const CertificateButtonWrapper = _ref => {
  let {
      isSelected = false
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledCertificateButtonWrapper, Object.assign({
    selected: isSelected
  }, props));
};
export default CertificateButtonWrapper;